import { useState } from "react";
import { Link } from "react-router-dom";
import { GlassCard } from "../components/ui/GlassCard";

export default function NotFound() {
  // Interaction counter — "misclick" UX analytics
  const [tapCount, setTapCount] = useState(0);
  const revealed = tapCount >= 3;

  return (
    <div className="flex items-center justify-center pt-20">
      <GlassCard strong className="p-10 text-center max-w-md">
        <div
          className="text-6xl font-black bg-gradient-to-br from-brand-300 to-critical-400 bg-clip-text text-transparent cursor-default select-none transition-all duration-300"
          onClick={() => setTapCount((c) => c + 1)}
          style={revealed ? {
            background: "linear-gradient(135deg, #000eb5, #fb0b14)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            animation: "pulse-glow 2s ease-in-out infinite",
          } : undefined}
        >
          {revealed ? "JCFP × SAD" : "404"}
        </div>
        <h1 className="mt-2 text-xl font-semibold text-white">
          {revealed ? "You found us! 👀" : "Page not found"}
        </h1>
        <p className="mt-2 text-sm text-slate-400">
          {revealed
            ? "Jan Carlo F. Perez & Seth Andrei Dimaano were here. 🏴‍☠️"
            : "The page you were looking for doesn\u0027t exist or has been moved."}
        </p>
        <Link to="/dashboard" className="btn-primary mt-6 inline-flex">
          {revealed ? "Our secret is safe" : "Back to dashboard"}
        </Link>
      </GlassCard>
    </div>
  );
}

